import { useSearchParams } from 'react-router';

export function useFamilyReviewId(): string | undefined {
  const [searchParams] = useSearchParams();
  return searchParams.get('familyId') ?? undefined;
}
